import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import bgImage from '../../assets/Left Content.png';
import api from '../../services/Api';
import { FaLock } from 'react-icons/fa6';
import toast from 'react-hot-toast';
import { BeatLoader } from 'react-spinners';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    newPassword: '',
    confirmNewPassword: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmNewPassword) {
      toast.error('Passwords do not match');
      return;
    }

    const toastId = toast.loading('Resetting password...');
    setIsSubmitting(true);

    try {
      await api.post('/admin/forget-password', {
        token,
        newPassword: formData.newPassword,
        confirmNewPassword: formData.confirmNewPassword,
      });

      toast.success('Password successfully reset!', { id: toastId });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to reset password. Please try again.', {
        id: toastId,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  if (!token) {
    return (
      <div className="flex items-center justify-center h-screen px-4">
        <p className="text-center text-red-500">Invalid or missing reset token</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full h-screen md:flex-row">
      <div className="hidden h-full md:block md:w-1/2">
        <img src={bgImage} alt="background" className="object-cover w-full h-full" />
      </div>
      <div className="flex items-center justify-center w-full p-4 md:w-1/2 sm:p-6 md:p-8">
        <form onSubmit={handleSubmit} className="w-full max-w-[400px]">
          <div className="mx-auto mb-6 text-center sm:mb-8">
            <h1 className="mb-2 text-xl font-bold text-gray-800 sm:text-2xl md:text-3xl">
              Reset Password
            </h1>
            <p className="text-sm text-gray-600 sm:text-base">Create a new password</p>
          </div>

          <div className="relative mb-4">
            <FaLock className="absolute text-sm text-gray-400 transform -translate-y-1/2 left-4 sm:left-5 top-1/2 sm:text-base" />
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              placeholder="New Password"
              value={formData.newPassword}
              onChange={handleChange}
              className="w-full h-12 pl-10 pr-4 text-sm placeholder-gray-400 bg-white border border-gray-200 rounded-full sm:h-14 sm:pl-12 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent sm:text-base"
              required
            />
          </div>

          <div className="relative mb-6">
            <FaLock className="absolute text-sm text-gray-400 transform -translate-y-1/2 left-4 sm:left-5 top-1/2 sm:text-base" />
            <input
              type="password"
              id="confirmNewPassword"
              name="confirmNewPassword"
              placeholder="Confirm New Password"
              value={formData.confirmNewPassword}
              onChange={handleChange}
              className="w-full h-12 pl-10 pr-4 text-sm placeholder-gray-400 bg-white border border-gray-200 rounded-full sm:h-14 sm:pl-12 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent sm:text-base"
              required
            />
          </div>

          <button
            type="submit"
            className="flex items-center justify-center w-full h-12 text-sm font-medium text-white transition-colors bg-black rounded-full sm:h-14 hover:bg-gray-800 sm:text-base disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isSubmitting}>
            {isSubmitting ? <BeatLoader color="#ffffff" size={10} /> : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
